export default __webpack_public_path__ + "static/media/tailwind.01daca9b.svg";